import PreventionCategory from './PreventionCategory'
import Prevention_Minimal from './Prevention_Minimal'

export default {
    Prevention_Minimal,
    ...PreventionCategory,
}
